<script>
import 'iconify-icon';

export default {};
</script>

<template>
  <div class="flex flex-col h-full w-72 bg-gray-900">
    <div class="flex-1 flex flex-col pb-4 overflow-y-auto pt-8">
      <RouterLink
        v-if="$currentAccount.logo"
        :to="{ name: 'accounts.show', params: { accountId: $currentAccount.id } }"
      >
        <img :src="$currentAccount.logo" class="block rounded w-24 mb-8 mx-auto" />
      </RouterLink>
      <h6 class="text-center text-white mb-6">
        {{ $currentAccount.name }}
      </h6>
      <div class="px-6">
        <nav class="flex flex-1 flex-col">
          <ul role="list" class="flex flex-1 flex-col gap-y-7">
            <li v-for="(group, groupIdx) in $currentAccount.navigation" :key="groupIdx">
              <div v-if="group.title" class="text-xs font-semibold leading-6 text-gray-400">
                {{ group.title }}
              </div>
              <ul role="list" class="-mx-2 space-y-1">
                <template v-for="item in group.items">
                  <li v-if="(item.show || (() => true))()" :key="item.name">
                    <RouterLink
                      v-if="item.version === 'v1'"
                      :to="item.href"
                      custom
                      v-slot="{ isActive, isExactActive, href, navigate }"
                    >
                      <a
                        :href="href"
                        :class="[
                          (item.exact ? isExactActive : isActive)
                            ? 'bg-gray-800 text-white'
                            : 'text-gray-400 hover:text-white hover:bg-gray-800',
                          'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold transition-colors',
                        ]"
                        @click="navigate"
                      >
                        <iconify-icon v-if="item.icon" height="24" :icon="item.icon"></iconify-icon>
                        <span v-else class="h-6 w-6 inline-flex shrink-0" />
                        {{ item.title }}
                      </a>
                    </RouterLink>
                    <a
                      v-else
                      :href="item.href"
                      :class="[
                        'text-gray-400 hover:text-white hover:bg-gray-800 group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold transition-colors',
                      ]"
                    >
                      <iconify-icon v-if="item.icon" height="24" :icon="item.icon"></iconify-icon>
                      <span v-else class="h-6 w-6 inline-flex shrink-0" />
                      {{ item.title }}
                    </a>
                  </li>
                </template>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>
